
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/education/[section]/[...slug]",
      function () {
        return require("private-next-pages/education/[section]/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/education/[section]/[...slug]"])
      });
    }
  